import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

const translations = {
  en: {
    quickLinks: "Quick Links",
    aboutUs: "About Us",
    ourOffices: "Our Offices",
    info: "info",
    mobile: "Mobile",
    chipsetExpertise: "Chipset",
    visionandimageProcessing: "Vision & Image Processing",
    crm: "CRM Tech",
    cloud: "Cloud & Data",
    qa: "Process & QA",
    software: "Software Engineering",
    privacyPolicy: "Privacy Policy",
    termsAndConditions: "Terms and Conditions",
    contactus: "Contact Us",
    name: "Name",
    email: "Email",
    phone: "Phone Number",
    message: "Message",
    namePlaceholder: "Enter your name ",
    emailPlaceholder: "Enter your email",
    phonePlaceholder: "Enter your phone number",
    queryPlaceholder: "Enter your query",
    apply: "Apply Now",
    fullName: "Full Name",
    curLocation: "Current Location",
    resume: "Resume/CV",
    submit: "Submit",
    fullNamePlaceholder: "Enter yur Full Name",
    locationPlaceholder: "Enter your current location",
  },
  "ko-KR": {
    quickLinks: "빠른 링크",
    aboutUs: "회사소개",
    ourOffices: "우리의 사무실",
    info: "정보",
    mobile: "모바일",
    chipsetExpertise: "칩셋",
    visionandimageProcessing: "비전 및 이미지 처리",
    crm: "CRM 기술",
    cloud: "클라우드 & 데이터",
    qa: "프로세스 및 품질 보증",
    software: "소프트웨어 엔지니어링",
    privacyPolicy: "개인정보처리방침",
    termsAndConditions: "이용약관",
    contactus: "문의하기",
    name: "이름",
    email: "이메일",
    phone: "전화번호",
    message: "메시지",
    namePlaceholder: " 이름을 입력해 주세요",
    emailPlaceholder: " 이메일을 입력하세요",
    phonePlaceholder: "전화번호를 입력하세요",
    queryPlaceholder: "질문을 입력하세요",
    apply: "지금 신청하기",
    fullName: "성명",
    curLocation: "현재 위치",
    resume: "이력서/CV",
    submit: "제출",
    fullNamePlaceholder: "이름을 입력하세요",
    locationPlaceholder: "현재 위치를 입력하세요",
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Initialize from localStorage or default to 'en'
    return localStorage.getItem("language") || "en";
  });

  useEffect(() => {
    // console.log("Current language:", language);
    // Save the selected language to localStorage whenever it changes
    localStorage.setItem("language", language);
  }, [language]);

  // Ensure the translations object exists for the current language
  const t = translations[language] || translations.en; // Default to 'en' if language not found

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook to use the language context
export const useLanguage = () => useContext(LanguageContext);
